import React, { useState } from "react";

import { DropGroupProps } from "./types";

import {
  List,
  Label,
  Filter,
  Disabled,
  Selected,
  ListItem,
  Container,
  OneList,
} from "./styles";

import arrowSource from "application/assets/images/icons/arrow-down.svg";
import acceptSource from "application/assets/images/icons/green-accept.svg";
import OptionalTooltip from "../OptionalTooltip";
import {IndexItem} from "../../../common/home/store/model";

const DropGroup = ({
  data,
  label,
  disabled,
  selected,
  placeholder,
  onSelect,
  tooltip
}: DropGroupProps) => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => setVisible(!visible);

    const handleSelect = (item: IndexItem) => {
      const currentSelected = selected || [];

      const isAlreadySelected = currentSelected.some((s) => s.id === item.id && s.type === item.type);

      let newSelected: IndexItem[];

      if (isAlreadySelected) {
        newSelected = currentSelected.filter((s) => s.id !== item.id || s.type !== item.type);
      } else {
        newSelected = [...currentSelected, item];
      }

      onSelect(newSelected);
    };


  const renderList = () => {
    return (
      <OneList>
        {data?.map((item) => {
          const isSelected = selected?.some((s) => s.id === item.id && s.type === item.type);
          return (
            <ListItem
              key={item.name}
              isSelected={isSelected}
              onClick={() => handleSelect(item)}
            >
              <p>{item.name}</p>
              {isSelected && <img src={acceptSource} alt="accept" />}
            </ListItem>
          );
        })}
      </OneList>
    )
  };

  const renderSelectedText = () => {
    if (!selected || selected.length === 0) {
      return placeholder;
    }

    return selected.map((item) => item.name).join(", ");
  };

  return (
    <div className="drop-group-wrapper">
      <OptionalTooltip text={tooltip || ''}><Label className="drop-group-label">{label}</Label></OptionalTooltip>
      <Container visible={visible} className="drop-group-container">
        {disabled && <Disabled />}
        <Selected onClick={toggleVisible} className="drop-group-selected">
          <p>{renderSelectedText()}</p>
          <img src={arrowSource} alt="arrow" />
        </Selected>
        {visible && <List>{renderList()}</List>}
      </Container>
      {visible && <Filter onClick={toggleVisible} />}
    </div>
  );
};

export default DropGroup;
